import React, { useState, useEffect } from 'react';
import { motion, Variants } from 'framer-motion';
import { podcastsService } from '../services/api';
import { Podcast } from '../types';
import { useAudioPlayer } from '../contexts/AudioPlayerContext';
import SiteBrandedLoader from '../components/SiteBrandedLoader';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8 },
  },
} satisfies Variants;

const stagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15, delayChildren: 0.1 },
  },
} satisfies Variants;
const PAGE_SURFACE = '#f4f7fc';
const pulseFloat = {
  hidden: { opacity: 0.6, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, repeat: Infinity, repeatType: 'reverse' },
  },
} satisfies Variants;

const Podcasts: React.FC = () => {
  const [podcasts, setPodcasts] = useState<Podcast[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { currentPodcast, isPlaying, playPodcast, currentTime, duration, seek, togglePlayPause } = useAudioPlayer();

  useEffect(() => {
    const fetchPodcasts = async () => {
      try {
        const data = await podcastsService.getPublished();
        setPodcasts(data);
      } catch (err: any) {
        setError(err.response?.data?.message || 'خطا در دریافت پادکست‌ها');
      } finally {
        setLoading(false);
      }
    };

    fetchPodcasts();
  }, []);

  const handlePlayPause = (podcast: Podcast) => {
    playPodcast(podcast);
  };

  if (loading) {
    return (
      <SiteBrandedLoader
        variant="fullscreen"
        tone="dark"
        size="lg"
        message="در حال بارگذاری پادکست‌ها..."
      />
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: PAGE_SURFACE }}>
        <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded max-w-md">
          {error}
        </div>
      </div>
    );
  }

return (
  <div className="min-h-screen" style={{ backgroundColor: PAGE_SURFACE }} dir="rtl">
    <div className="mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center px-4 py-12 sm:px-8">
      <motion.div
        variants={pulseFloat}
        initial="hidden"
        animate="visible"
        className="mx-auto inline-flex w-full max-w-2xl items-center justify-center gap-2 rounded-2xl border border-violet-200 bg-violet-50/90 px-5 py-4 text-center text-sm font-bold text-violet-700 shadow-sm sm:text-base"
      >
        <span className="relative flex h-2.5 w-2.5 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-violet-400 opacity-75" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-violet-500" />
        </span>
        صفحه پادکست ها در حال بروزرسانی است و به زودی با نسخه جدید منتشر می شود
      </motion.div>
    </div>
  </div>
);
};

export default Podcasts;
